"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Unhandled error:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#121110] px-5 font-[family-name:var(--font-body)]">
      <span className="font-[family-name:var(--font-display)] text-8xl text-[#2A2825]">
        500
      </span>
      <h1 className="mt-4 font-[family-name:var(--font-display)] text-2xl tracking-wide text-[#E8E4DF]">
        SOMETHING WENT WRONG
      </h1>
      <p className="mt-2 text-[15px] text-[#9A958B]">
        An unexpected error occurred. Please try again.
      </p>
      <button
        onClick={reset}
        className="mt-8 cursor-pointer rounded-md bg-[#F59E0B] px-5 py-2.5 text-[15px] font-semibold text-[#121110] transition hover:bg-[#FCD34D]"
      >
        Try Again
      </button>
    </div>
  );
}
